module.exports = __webpack_public_path__ + "static/media/siraya_front.6fdaf264.png";